module.exports = __webpack_public_path__ + "img/loading.3c68f742.svg";